module.exports = __webpack_public_path__ + "media/images/lp/1/plight2-pc-f5dc51c3d68cf3cb44e1810093a4fd47.png";